// tslint:disable
/* MACLE TypeScript 31/07/2026 23:43:12 */
import { DataParametrosAPP, DataContaAPP } from '../vo/sitevo.vo';

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { BaseService, AjaxService, IModelServiceResponse, Parser, ArrayList } from 'maf-web';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class ParametrosModelService extends BaseService {
  private _url = 'parametrosService?action=';

  constructor(router: Router, ajax: AjaxService, private toastrService: ToastrService) {
    super(router, ajax, toastrService);
  }

  public getParametrosApp(): Promise<DataParametrosAPP> {
    return this.ajax.get(this._url + 'getParametrosApp')
      .then((r: IModelServiceResponse<DataParametrosAPP>) => Parser.jsonToClass(r.value, DataParametrosAPP))
      .catch((error: any) => this.handleError(error));
  }

  public getContaByEmpresa(codEmpresa: number): Promise<DataContaAPP> {
    let params = {
      "codEmpresa": codEmpresa
    };
    return this.ajax.post(this._url + 'getContaByEmpresa', params)
      .then((r: IModelServiceResponse<DataContaAPP>) => Parser.jsonToClass(r.value, DataContaAPP))
      .catch((error: any) => this.handleError(error));
  }

  public getServidorConsultaByCodClienteMacle(codClienteMacle: number): Promise<string> {
    let params = {
      "codClienteMacle": codClienteMacle
    };
    return this.ajax.post(this._url + 'getServidorConsultaByCodClienteMacle', params)
      .then((r: IModelServiceResponse<string>) => r.value)
      .catch((error: any) => this.handleError(error));
  }

}


